import script from "./CollectiviteMembreRevolving.vue?vue&type=script&setup=true&lang=ts"
export * from "./CollectiviteMembreRevolving.vue?vue&type=script&setup=true&lang=ts"

import "./CollectiviteMembreRevolving.vue?vue&type=style&index=0&id=3be896a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3be896a6"]])

export default __exports__